import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

window.addEventListener('load', () => {
  onElelementExistRunOnce('.fertilizers_new_page, .fertilizers_edit_page', () => {
    void (async () => {
      try {
        const { default: Component } = await import(
          './internal/fertilizers_new_page__fertilizers_edit_page'
        );
        await Promise.resolve(Component());
      } catch (error) {
        console.error(error); // eslint-disable-line no-console -- report failed page initialization
      }
    })();
  });
});
